import { StatusIcon } from "app/components/Icons";
import CommonStatusSelection from "app/containers/Features/components/CommonStatusSelection";
import { getStatusById } from "app/containers/Features/containers/Boards/helpers";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import StatusSelectionButton from "./StatusSelectionButton";
import clsx from "clsx";
import { dropdownTriggerClassname } from "app/components/Dropdown";

interface StatusDropdownProps {
  value: string;
  setValue: (value: string) => void;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({ setValue, value }) => {
  const statusData = useSelector(selectTicketStatus);

  const handleSelect = (data: ITicketStatus) => {
    setValue(data._id);
  };
  const selectedStatus = useMemo(() => {
    return getStatusById(statusData, value);
  }, [statusData, value]);


  return (
    <CommonStatusSelection
      trigger={
        <button className={clsx("flex items-center justify-between w-full px-2 py-2 rounded-md ",dropdownTriggerClassname)}>
          <StatusSelectionButton
            label="Status:"
            icon={<StatusIcon size={16}  color="#79808A"/>}
            className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
            selectedIcon={
              selectedStatus && (
                <StatusIcon size={18} color={selectedStatus?.color} />
              )
            }
            selectedLabel={selectedStatus?.name}
            textColor={selectedStatus?.color}
            textClassName="text-[12px] leading-[18px] font-medium "
          />
        </button>
      }
      align="end"
      value={selectedStatus?._id}
      setValue={handleSelect}
    />
  );
};

export default StatusDropdown;
